import { tellResult } from "@/utils/bridge";
const paypalKeys = {
  sandbox: 'AX5vfcYDtFozbck0P50lFwJRomLgIHXN7IrdtjUJp6lID6O4378J-UrskVRk2YKUDTLLXM5KoShx1wi9',
  production: 'AfsbIVcyKnsCJhd1Qtqs8orDL1dUNlFBLZnD4cJzR6hPaT7UblYC6ACn9KKoGLat4-LqlhAAHMtf3rjC'
};
const usePaypal = (amount, currency, orderId) => {
  const paypalCanClick = ref(false);
  const timer = ref(0);
  const {
    load
  } = useScriptTag('/js/paypal-checkout.min.js', () => {}, {
    manual: true
  });
  load();
  const renderPaypal = async ele => {
    if (!window.paypal) {
      await load();
    }
    return window.paypal.Button.render({
      env: _env.env,
      client: paypalKeys,
      style: {
        label: 'pay',
        size: 'responsive',
        shape: 'rect',
        color: 'gold',
        tagline: false
      },
      commit: true,
      payment: async function (pResult, actions) {
        setTimeout(() => {
          const paypalPopup = document.querySelector('.paypal-checkout-sandbox');
          if (paypalPopup) {
            paypalPopup.style.top = document.body.style.getPropertyValue('--safe-top');
            paypalPopup.style.height = 'calc(100vh - var(--safe-top))';
            paypalPopup.style.maxHeight = 'calc(100% - var(--safe-top))';
            paypalPopup.style.minHeight = 'calc(100% - var(--safe-top))';
          }
        }, 500);
        return actions.payment.create({
          payment: {
            transactions: [{
              invoice_number: unref(orderId),
              notify_url: "https://api.solotech.me/trade/paypal/token",
              amount: {
                details: {},
                total: unref(amount) + '',
                currency: unref(currency) || 'USD'
              }
            }]
          },
          experience: {
            input_fields: {
              no_shipping: 1
            }
          }
        });
      },
      onAuthorize: function (pResult, actions) {
        console.log('pResult', pResult);
        return actions.payment.execute().then(function (paymentDetails) {
          tellResult('success', {
            paymentId: paymentDetails.id,
            orderId: unref(orderId),
            type: 'paypal'
          });
        });
      },
      onCancel: function (data, actions) {
        tellResult('cancel', {
          data,
          type: 'paypal'
        });
      },
      onError: function (err) {
        tellResult('error', {
          err,
          type: 'paypal'
        });
      }
    }, ele).then(() => {
      //解决渲染2个paypal button的问题
      nextTick(() => {
        const btn = document.querySelectorAll('#paypal-button .paypal-button');
        if (btn && btn.length > 1) {
          for (let i = 1; i < btn.length; i++) {
            // btn[i].style.display='none'
            document.getElementById(ele).removeChild(btn[i]);
          }
        }
      });
      // 在paypal加载完成之前加上一个loading
      let i = 0;
      timer.value = setInterval(() => {
        i++;
        if (i >= 30) {
          // logger('paypal render timeout','paypal loading layer had run more than 6s')
          clearInterval(timer.value);
          // emitters('paypalTimeout')
          return;
        }
        const iframes = document.querySelectorAll('#paypal-button iframe');
        if (iframes[0] && iframes[0].className.indexOf('prerender') >= 0) {
          // console.log('paypal不能点击')
          paypalCanClick.value = false;
        } else {
          // console.log('paypal能点击')
          paypalCanClick.value = true;
          // emitters('canClick')
          clearInterval(timer);
        }
      }, 200);
    }).catch(err => {
      tellResult('error', {
        type: 'paypal',
        err
      });
    });
  };
  return {
    renderPaypal,
    paypalCanClick
  };
};
export default usePaypal;